const fn = {
    init: () => {
        if ($('.main-navigation .navigation-box').length) {
            var subMenu = $('.main-navigation .submenu');
            subMenu.parent('li').children('a').append(function() {
                return '<button class="sub-nav-toggler"> <span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button>';
            });
            var mainNavToggler = $('.header-navigation .menu-toggler');
            var subNavToggler = $('.main-navigation .sub-nav-toggler');
            mainNavToggler.on('click', function() {
                var Self = $(this);
                var menu = Self.closest('.header-navigation').find(Self.data('target'));
                $(menu).slideToggle();
                $(menu).toggleClass('showen');
                return false;
            });
            subNavToggler.on('click', function() {
                var Self = $(this);
                Self.parent().parent().children('.submenu').slideToggle();
                return false;
            });
        }
        if ($('.stricky').length) {
            $('.stricky')
                .addClass('original')
                .clone(true)
                .insertAfter('.stricky')
                .addClass('stricked-menu')
                .removeClass('original');
        }
        $(window).on('scroll', function() {
            if ($('.scroll-to-top').length) {
                var strickyScrollPos = 100;
                if ($(window).scrollTop() > strickyScrollPos) {
                    $('.scroll-to-top').fadeIn(500);
                } else {
                    $('.scroll-to-top').fadeOut(500);
                }
            }
            if ($('.stricked-menu').length) {
                var headerScrollPos = 100;
                var stricky = $('.stricked-menu');
                if ($(window).scrollTop() > headerScrollPos) {
                    stricky.addClass('stricky-fixed');
                } else {
                    stricky.removeClass('stricky-fixed');
                }
            }
        });
        if ($('.accrodion-grp').length) {
            var accrodionGrp = $('.accrodion-grp');
            accrodionGrp.each(function() {
                var accrodionName = $(this).data('grp-name');
                var Self = $(this);
                var accordion = Self.find('.accrodion');
                Self.addClass(accrodionName);
                Self.find('.accrodion .accrodion-content').hide();
                Self.find('.accrodion.active').find('.accrodion-content').show();
                accordion.each(function() {
                    $(this).find('.accrodion-title').on('click', function() {
                        if ($(this).parent().hasClass('active') === false) {
                            $('.accrodion-grp.' + accrodionName).find('.accrodion').removeClass('active');
                            $('.accrodion-grp.' + accrodionName).find('.accrodion').find('.accrodion-content').slideUp();
                            $(this).parent().addClass('active');
                            $(this).parent().find('.accrodion-content').slideDown();
                        }
                    });
                });
            });
        }
    }
}

export default {
    can: true,
    run: fn.init,
};
